import api from './axiosConfig';

/**
 * Get forecast data for a specific stock item
 * @param {string} stockItemId - The ID of the stock item
 * @returns {Promise<Object>} Forecast data including current inventory, pending orders, and confirmed shipments
 * @throws {string} Error message if the request fails
 */
export const getStockForecast = async (stockItemId) => {
    try {
        const response = await api.get(
            `/api/stock-items/${stockItemId}/forecast/`
        );
        return response.data;
    } catch (error) {
        console.error('Stock forecast API error:', {
            message: error.message,
            response: error.response?.data,
            stockItemId
        });
        throw error.response?.data?.detail || error.message;
    }
}; 